import React from 'react'
import { Select } from 'antd'
import { merge } from 'lodash'

const { Option } = Select

interface ClientSelectProps {
  companies: { id: string; companyName: string }[]
  defaultCompanyId?: string
  selectedCompanyId?: string
  selectPlaceholder?: string
  onChange: (selectedCompanyId: string) => void
  allCompaniesPlacholder?: { id: string; companyName: string }
  style?: JSX.IntrinsicElements['div']['style']
  disabled?: boolean
}

function ClientSelect({
  allCompaniesPlacholder,
  companies,
  selectedCompanyId,
  defaultCompanyId,
  onChange,
  selectPlaceholder = 'Select a company',
  style,
  disabled = false,
}: ClientSelectProps) {
  let selectCompanies = [...companies]
  selectCompanies.sort((a, b) =>
    b.companyName.toLowerCase() > a.companyName.toLowerCase() ? -1 : 1
  )
  if (allCompaniesPlacholder) {
    selectCompanies = [allCompaniesPlacholder, ...selectCompanies]
  }

  const handleCompanyChange = (value: string) => {
    onChange(value)
  }

  return (
    <Select
      showSearch
      optionFilterProp="children" // filter by what's rendered (companyName)
      placeholder={selectPlaceholder}
      style={merge({ width: 200 }, style)}
      onChange={handleCompanyChange}
      disabled={disabled}
      value={selectedCompanyId ?? defaultCompanyId}
      defaultValue={defaultCompanyId ?? undefined}
    >
      {selectCompanies.map(({ id, companyName }) => (
        <Option key={id} value={id}>
          {companyName}
        </Option>
      ))}
    </Select>
  )
}

export default ClientSelect
